// Keep draft grouping labels separate from the name sent to the API.
const hasName = value => typeof value === 'string' && value.trim().length > 0;
const display = (kind, value) => hasName(value) ? value : kind === 'home' ? '未命名主页' : '未命名作品';
const model = (item = {}, kind = item.contentType) => {
  if (kind !== 'work' && kind !== 'home') throw new Error('content_entity_type_required');
  const raw = Object.prototype.hasOwnProperty.call(item, 'name') ? item.name
    : Object.prototype.hasOwnProperty.call(item, 'title') ? item.title : item.displayTitle;
  return { ...item, contentType: kind, displayTitle: display(kind, raw) };
};
function normalize(value) {
  if (!value || typeof value !== 'object') return value;
  let result = value;
  Object.keys(value).forEach(key => {
    const next = normalize(value[key]);
    if (next !== value[key]) {
      if (result === value) result = Array.isArray(value) ? value.slice() : { ...value };
      result[key] = next;
    }
  });
  return !Array.isArray(result) && ['work', 'home'].includes(result.contentType) ? model(result) : result;
}
export default { hasName, display, model, normalize, patch: (item, changes) => model({ ...item, ...changes }), work: value => display('work', value), home: value => display('home', value) };
